import { render, staticRenderFns } from "./CardProfileImage.vue?vue&type=template&id=62adcc16"
import script from "./CardProfileImage.vue?vue&type=script&lang=js"
export * from "./CardProfileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports